import React, { useEffect, useState } from "react";
import { AiOutlineMenu } from "react-icons/ai";
import { FiShoppingCart } from "react-icons/fi";
import { BsChatLeft } from "react-icons/bs";
import { RiNotification3Line } from "react-icons/ri";
import { MdKeyboardArrowDown } from "react-icons/md";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";

import avatar from "../data/avatar.jpg";
import { Cart, Chat, Notification, UserProfile } from ".";
import { useStateContext } from "../contexts/ContextProvider";
import { BASE_URL, get, post, put } from '../Services/Calls';


const NavButton = ({ title, customFunc, icon, color, dotColor }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ color }}
      className="relative text-xl rounded-full p-3 hover:bg-light-gray"
    >
      <span
        style={{ background: dotColor }}
        className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
      />
      {icon}
    </button>
  </TooltipComponent>
);

const Navbar = () => {
  const {
    currentColor,
    activeMenu,
    setActiveMenu,
    handleClick,
    isClicked,
    setScreenSize,
    screenSize,
  } = useStateContext();

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (screenSize <= 900) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }, [screenSize]);

  const handleActiveMenu = () => setActiveMenu(!activeMenu);
  const [countryData, setCountryData] = useState([]);
  const [loginData, setLoginData] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");


  useEffect(() => {
    const tempLoginData = JSON.parse(localStorage.getItem('loginData'));
  if (tempLoginData) {
    setLoginData(tempLoginData);
  }
  }, [])



useEffect(() => {
(async () => {
      await getCountries();
    })();

    const saved = localStorage.getItem("selectedCountry");
    if (saved) {
      setSelectedCountry(saved);
    }
  }, []);

  // Save to localStorage whenever user changes the selection
  const handleChange = (e) => {
    const value = e.target.value;
    setSelectedCountry(value);
    localStorage.setItem("selectedCountry", value);
    window.location.reload();
  };

 const getCountries = async () => {
    try {
      const response = await get(BASE_URL + '/countries?order=ASC');
      if (response && response.length > 0) {
        const sortedData = response.sort((a, b) => a.name.localeCompare(b.name));
        setCountryData(sortedData);
      }
    }
    catch (ex) {
      alert(ex)
    }
  }


  return (
    <div className="flex justify-between p-2 md:ml-6 md:mr-6 relative">
      <NavButton
        title="Menu"
        customFunc={handleActiveMenu}
        color={currentColor}
        icon={<AiOutlineMenu style={{height:25,width:25}} />}
      />

      
      <div className="flex">
             <select
        className="border px-4 py-2 rounded"
        value={selectedCountry}
        onChange={handleChange}
        style={{paddingRight:20,marginRight:'30px'}}
      >
        <option value="">All Countries</option>
       {/*  {country.map((c) => (
          <option key={c.code} value={c.code}>
            {c.name}
          </option>
        ))} */}


 {countryData && countryData.length > 0 && countryData.map((item, index) => (
   <option style={{color:'#000000'}} key={item.id} value={item.id}>{item.name}</option>
))}


      </select>
      {/* </div>


      <div className="flex"> */}
        <TooltipComponent content="Profile" position="BottomCenter">
          <div
            className="flex items-center gap-2 cursor-pointer p-1 hover:bg-light-gray rounded-lg"
            onClick={() => handleClick("userProfile")}
          >
            <img
              className="rounded-full w-8 h-8"
              src={avatar}
              alt="user-profile"
            />
            <p>
              <span className="text-gray-400 text-14">Hi,</span>{" "}
              <span className="text-gray-400 font-bold ml-1 text-14">
               {loginData.email}
              </span>
            </p>
            <MdKeyboardArrowDown className="text-gray-400 text-14" />
          </div>
        </TooltipComponent>
        {isClicked.userProfile && <UserProfile />}
      </div>
    </div>
  );
};

export default Navbar;
